import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTorch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTorch"><Path fillRule="evenodd" clipRule="evenodd" d="M18.6982 14.7588L18.2529 15.2061L14.5352 15.4385L7.28906 22.6855L1.31445 16.7109L8.56055 9.46387L8.79395 5.74707L8.99512 5.54688L9.24023 5.30078L18.6982 14.7588ZM8.96973 13.9697L10.0303 15.0303L12.5303 12.5303L11.4697 11.4697L8.96973 13.9697Z" fill="currentColor"/><Path d="M22.9355 10.5234L19.7588 13.6982L10.3008 4.24023L13.4766 1.06445L22.9355 10.5234Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTorch;
